<template>
  <div>
    <h2>Dołącz</h2>
    <app-input name="code" type="text" placeholder="Kod zaproszeniowy" v-model="form.inviteCode" autocomplete="off"></app-input>
    <small class="form-info" v-if="this.form.correct" >{{ organizationName }}</small>
    <small class="form-error" v-else >{{ error }}</small>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import Input from "@/components/Input.vue";
import {api} from '@/api.js'

export default {
  name: 'join-organizations',
  data() {
    return {
      organizationName: 'Nazwa',
      error: '',
      form: {
        correct: false,
        inviteCode: '',
      }
    }
  },
  methods: {
    async checkIfCodeExists() {
      this.error = ''
      let flag = false
      try {
        const response = await api.post(`/invitations/${this.inviteCode}`,)
        // console.log(response.data);
        flag = true
        this.form = {...this.form, organization: response.data.organization}
        this.organizationName = response.data.organization.name

      } catch (e) {
          console.error(e)
          this.error = 'Kod jest niepoprawny!'
        // if(!e.response.data.message)
        //   console.error(e)
      }
      return flag
    }
  },
  watch: {
    'form.inviteCode': {
      handler: debounce(async function(val) {
        this.inviteCode = val
        this.form.correct = await this.checkIfCodeExists()
        this.$emit('updateForm', this.form)
      }, 400),
      deep: true
    }
  },
  components: {
    appInput: Input
  }
}
</script>

<style lang="scss" scoped>

</style>
